import { isReferralEnabled } from "@/helpers/referral.helper";

/**
 * Vuex store module for managing referral-related state
 */
const getDefaultState = () => ({
  referralRewardDetails: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    referralRewardDetails: state => state.referralRewardDetails,
    shouldShowReferralLink: (state, getters, rootState) => {
      return isReferralEnabled(rootState.partnerInfo?.partnerState);
    },
  },
  actions: {
    setReferralRewardDetails({ commit }, payload) {
      commit("setReferralRewardDetails", payload);
    },
    resetReferralState({ commit }) {
      commit("resetState");
    },
    // Aliased for the root resetState action, which now dispatches
    // `${moduleKey}/resetState` across all top-level modules.
    resetState({ commit }) {
      commit("resetState");
    },
  },
  mutations: {
    setReferralRewardDetails(state, payload) {
      state.referralRewardDetails = payload;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  },
};
